// extracted by mini-css-extract-plugin
export var chevronIcon = "_96-2";
export var teamName = "_96-1";
export var teamSwitcherButton = "_96-0";